import {
  SUPER_ADMIN,
  dcsAdmin1Roles,
  dcsAdmin2Roles,
  dcsAdmin3Roles,
  dcsAdmin4Roles,
  DCS_CONSUMER_APPLICATION_INCHARGE,
  DCS_CONSUMER_APPLICATION_OPERATOR,
  otherUtilitiesAdmin1Roles,
  otherUtilitiesAdmin2Roles,
  otherUtilitiesAdmin4Roles,
  otherUtilitiesApplicationAdmin3Roles,
  otherUtilitiesApplicationAdmin4Roles,
  otherUtilitiesAdmin3Roles,
  DCS_CONSUMER_BILLING_INCHARGE,
  DCS_CONSUMER_BILLING_OPERATOR,
  otherUtilitiesBillingAdmin3Roles,
  otherUtilitiesBillingAdmin4Roles,
} from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";
import { getOptionValue } from "common/enums";

const getUtilityWiseRoles = (utilityId, isBilling = false) => {
  switch (utilityId) {
    case getOptionValue("otherUtilityApplicationOptions", "DCS"):
      return {
        admin1Roles: dcsAdmin1Roles,
        admin2Roles: dcsAdmin2Roles,
        admin3Roles: isBilling
          ? [DCS_CONSUMER_BILLING_INCHARGE]
          : [DCS_CONSUMER_APPLICATION_INCHARGE],
        admin4Roles: isBilling
          ? [DCS_CONSUMER_BILLING_OPERATOR]
          : [DCS_CONSUMER_APPLICATION_OPERATOR],
        belowAdmin1Authorities: [
          ...dcsAdmin2Roles,
          ...dcsAdmin3Roles,
          ...dcsAdmin4Roles,
        ],
      };
    case getOptionValue("otherUtilityApplicationOptions", "Water"):
      return {
        admin1Roles: otherUtilitiesAdmin1Roles,
        admin2Roles: otherUtilitiesAdmin2Roles,
        admin3Roles: isBilling
          ? otherUtilitiesBillingAdmin3Roles
          : otherUtilitiesApplicationAdmin3Roles,
        admin4Roles: isBilling
          ? otherUtilitiesBillingAdmin4Roles
          : otherUtilitiesApplicationAdmin4Roles,
        belowAdmin1Authorities: [
          ...otherUtilitiesAdmin2Roles,
          ...otherUtilitiesAdmin3Roles,
          ...otherUtilitiesAdmin4Roles,
        ],
      };
    case getOptionValue("otherUtilityApplicationOptions", "Sewage"):
      return {
        admin1Roles: otherUtilitiesAdmin1Roles,
        admin2Roles: otherUtilitiesAdmin2Roles,
        admin3Roles: isBilling
          ? otherUtilitiesBillingAdmin3Roles
          : otherUtilitiesApplicationAdmin3Roles,
        admin4Roles: isBilling
          ? otherUtilitiesBillingAdmin4Roles
          : otherUtilitiesApplicationAdmin4Roles,
        belowAdmin1Authorities: [
          ...otherUtilitiesAdmin2Roles,
          ...otherUtilitiesAdmin3Roles,
          ...otherUtilitiesAdmin4Roles,
        ],
      };
    case getOptionValue("otherUtilityApplicationOptions", "Solid Waste"):
      return {
        admin1Roles: otherUtilitiesAdmin1Roles,
        admin2Roles: otherUtilitiesAdmin2Roles,
        admin3Roles: isBilling
          ? otherUtilitiesBillingAdmin3Roles
          : otherUtilitiesApplicationAdmin3Roles,
        admin4Roles: isBilling
          ? otherUtilitiesBillingAdmin4Roles
          : otherUtilitiesApplicationAdmin4Roles,
        belowAdmin1Authorities: [
          ...otherUtilitiesAdmin2Roles,
          ...otherUtilitiesAdmin3Roles,
          ...otherUtilitiesAdmin4Roles,
        ],
      };
    default:
      return {};
  }
};

export const getBillingApprovalStatusForOtherUtilities = (
  applicationStatus,
  userRoles,
  utilities
) => {
  const { admin3Roles, admin4Roles, admin2Roles } = getUtilityWiseRoles(
    utilities[0],
    true
  );
  const { approvedBy, revokedBy } = applicationStatus;

  if (isAuthorizedUser(userRoles, admin2Roles)) {
    return {
      canApproved: isAuthorizedUser(admin3Roles, approvedBy),
      canRevoked: isAuthorizedUser(admin3Roles, [...approvedBy, ...revokedBy]),
    };
  }

  if (isAuthorizedUser(userRoles, admin3Roles)) {
    return {
      canApproved:
        isAuthorizedUser(admin4Roles, approvedBy) ||
        isAuthorizedUser(admin2Roles, revokedBy),
      canRevoked:
        isAuthorizedUser(admin4Roles, approvedBy) ||
        isAuthorizedUser(admin2Roles, revokedBy),
    };
  }

  if (
    isAuthorizedUser(userRoles, admin4Roles) &&
    !approvedBy.length &&
    (!revokedBy.length || isAuthorizedUser(admin3Roles, revokedBy))
  ) {
    return {
      canApproved: true,
      canRevoked: false,
    };
  }

  return {
    canApproved: false,
    canRevoked: false,
  };
};

export const getApprovalStatusForOtherUtilities = (
  applicationStatus,
  userRoles,
  utilities
) => {
  const { approvedBy, rejectedBy } = applicationStatus;
  const { admin3Roles, admin4Roles } = getUtilityWiseRoles(utilities[0]);

  if (userRoles.includes(SUPER_ADMIN)) {
    return {
      canApproved: true,
      canRejected: true,
      canRevoked: false,
    };
  }

  if (isAuthorizedUser(userRoles, admin3Roles)) {
    return {
      canApproved: admin4Roles.includes(approvedBy),
      canRejected:
        admin4Roles.includes(approvedBy) || admin4Roles.includes(rejectedBy),
      canRevoked: admin4Roles.includes(rejectedBy),
    };
  }

  if (isAuthorizedUser(userRoles, admin4Roles) && !approvedBy) {
    return {
      canApproved: !approvedBy && !rejectedBy,
      canRejected: !approvedBy && !rejectedBy,
      canRevoked: false,
    };
  }

  return {
    canApproved: false,
    canRejected: false,
    canRevoked: false,
  };
};
